import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import moment from 'moment'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'

import styles from './RemindIssueLaterDialog.module.scss'

const RemindIssueLaterDialog = ({
  onClose,
  onSave,
  hotelName,
  prevRemindLaterReason,
  prevRemindLaterAfter,
  prevAddedBy,
  prevAddedOn
}) => {
  const [remindLaterReason, setRemindLaterReason] = useState(prevRemindLaterReason || '')
  const [remindLaterAfter, setRemindLaterAfter] = useState(
    prevRemindLaterAfter
      ? moment(prevRemindLaterAfter).format('YYYY-MM-DD')
      : moment().add(1, 'days').format('YYYY-MM-DD')
  )

  const { addToast } = useToasts()

  function handleConfirm() {
    if (remindLaterReason === '') {
      addToast('Please enter a reason', { appearance: 'error' })
      return
    }

    if (!remindLaterAfter) {
      addToast('Please enter a date', { appearance: 'error' })
      return
    }

    onSave({
      remindLaterReason,
      remindLaterAfter: moment(remindLaterAfter).format('YYYY-MM-DD')
    })
  }

  return (
    <ConfirmationDialog
      title={'Remind issue later'}
      onClose={onClose}
      positiveMessage="Save"
      theme="blacklist"
      contentPadding="0px"
      negativeMessage={prevRemindLaterAfter ? 'Delete reminder' : null}
      onConfirm={handleConfirm}
      onReject={() => onSave({ remindLaterReason: null, remindLaterAfter: null })}
    >
      <div className={styles.wrapper}>
        <div className={styles.info}>
          {prevAddedBy && prevAddedOn && (
            <div>
              Reminder added by {prevAddedBy} on{' '}
              {moment(prevAddedOn).format('DD MMM YYYY')}
            </div>
          )}
          {!prevAddedBy && !prevAddedOn && (
            <div>
              {' '}
              {hotelName} won't be visible in Needs Attention neither Onboarding lists
              until the reminder date.
            </div>
          )}
        </div>
        <TextInput
          label={'Reason'}
          onChangeValue={setRemindLaterReason}
          value={remindLaterReason}
        />
        <TextInput
          type="date"
          label={'Remind me after'}
          onChangeValue={setRemindLaterAfter}
          value={remindLaterAfter}
          min={moment().add(1, 'days').format('YYYY-MM-DD')}
        />
      </div>
    </ConfirmationDialog>
  )
}

export default RemindIssueLaterDialog
